import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Award, Trophy } from "lucide-react";

const color = (v) => (v == null ? "#94a3b8" : v >= 90 ? "#34D399" : v >= 70 ? "#22D3EE" : v >= 60 ? "#FB923C" : "#E11D48");

export function UnitTaskResult({ result, isGuide }) {
  const navigate = useNavigate();
  const blocks = Object.entries(result.blocks || {}).sort(([a], [b]) => Number(a) - Number(b));
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10" data-testid="ut-result">
      <div className="hq-glass rounded-3xl p-8 sm:p-10 border border-primary/40 w-full max-w-3xl hq-fade-up">
        <div className="text-center">
          <Trophy className="w-12 h-12 text-primary mx-auto" />
          <p className="text-[10px] uppercase tracking-widest text-primary font-mono-data mt-4">{(result.title || "").includes("Mid-Unit") ? "Mid-Unit Task Test" : "Unit Final Task"} · {isGuide || result.preview ? "Guide preview (not saved)" : result.passed ? "Passed" : "Completed"}</p>
          <h1 className="font-display text-4xl sm:text-5xl mt-1">{result.title || "Word Processing · Unit Final Task"}</h1>
          <p className="font-display text-7xl mt-6" style={{ color: color(result.score) }} data-testid="ut-overall-score">{result.score}%</p>
          <p className="text-sm text-muted-foreground mt-1">{(result.results || []).filter((r) => r.passed).length}/{result.total ?? (result.results || []).length} tasks correct · pass mark {result.pass || 70}% · grade {result.grade}{!isGuide && !result.preview ? ` · +${result.points_awarded} Horizon Points` : ""}</p>
          {result.auto_submitted && <p className="mt-3 text-sm text-[#E11D48]" data-testid="ut-auto-submitted">Submitted automatically because you left the test. Your Guide can see this.</p>}
        </div>
        <div className="grid grid-cols-5 gap-3 mt-8">
          {blocks.map(([b, v]) => (
            <div key={b} className="rounded-xl bg-white/[0.03] border border-white/10 p-3 text-center" data-testid={`ut-block-score-${b}`}>
              <p className="text-[10px] uppercase tracking-widest text-muted-foreground font-mono-data">Block {b}</p>
              <p className="font-display text-3xl mt-1" style={{ color: color(v) }}>{v == null ? "—" : `${v}%`}</p>
            </div>
          ))}
        </div>
        {result.results?.length > 0 && (
          <details className="mt-6">
            <summary className="text-sm text-[#22D3EE] cursor-pointer" data-testid="ut-result-details">See every task</summary>
            <ul className="mt-3 grid sm:grid-cols-2 gap-1.5 text-sm">
              {result.results.map((r) => <li key={`${r.screen}-${r.id}`} className={`flex items-start gap-2 ${r.passed ? "text-slate-200" : "text-slate-400"}`}><span className={r.passed ? "text-[#34D399]" : "text-[#E11D48]"}>{r.passed ? "✓" : "✗"}</span><span>{r.label} <span className="text-[10px] text-muted-foreground">· B{r.block}</span></span></li>)}
            </ul>
          </details>
        )}
        <div className="flex justify-center gap-3 mt-8">
          <Button data-testid="ut-back-to-studio" onClick={() => navigate("/studio/docs")} className="bg-[#22D3EE] text-[#04121f] hover:bg-[#67E8F9]"><Award className="w-4 h-4 mr-2" /> Back to Word Processing</Button>
        </div>
      </div>
    </div>
  );
}
